import { Component, ViewEncapsulation  } from '@angular/core';

import { FlowService } from './services/flow.service';
import { IconService } from './services/icon.service';
import { RemoteConfigService } from './services/firebase/remote-config.service';
import { MessagesService } from './modules/manager/services/messages.service';
import { APP_VERSION, isVersionBelowMinimum } from './shared/app-version';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent
{
    // SHFT-5757: both builds. Checked once at bootstrap; a full-screen
    // maintenance page is shown instead of the normal app content when true.
    maintenanceMode = false;

    constructor(
        flow: FlowService,
        iconService: IconService,
        private remoteConfig: RemoteConfigService,
        private messages: MessagesService,
    )
    {
        flow.register();
        iconService.connectIcons();

        this.remoteConfig.whenReady().then(() => {
            this.maintenanceMode = this.remoteConfig.maintenanceMode;
            this.checkStaleVersion();
        });
    }

    private checkStaleVersion(): void {
        const minSupportedVersion = this.remoteConfig.minSupportedVersion;
        if (!isVersionBelowMinimum(APP_VERSION, minSupportedVersion)) return;

        this.messages.add(
            'A new version is available, please reload.',
            '',
            'info',
            () => window.location.reload(),
            true,
            'Reload',
        );
    }
}
